module.exports = __webpack_public_path__ + "static/media/Shipwreck Survivor.65a9c0a7.jpg";